interface IncomeStepProps {
  wages: number;
  federalWithholding: number;
  onChangeWages: (next: number) => void;
  onChangeWithholding: (next: number) => void;
}

export function IncomeStep({
  wages,
  federalWithholding,
  onChangeWages,
  onChangeWithholding,
}: IncomeStepProps) {
  return (
    <div className="space-y-5">
      <div>
        <label
          htmlFor="wages"
          className="block text-base font-medium text-slate-900"
        >
          W-2 wages
        </label>
        <p className="mt-1 text-sm text-slate-500">
          From Box 1 of your W-2. This is your taxable wage income.
        </p>
        <div className="relative mt-2">
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
            $
          </span>
          <input
            id="wages"
            type="number"
            inputMode="decimal"
            min={0}
            step={1}
            value={Number.isFinite(wages) ? wages : 0}
            onChange={(e) => {
              const v = e.target.value === '' ? 0 : Number(e.target.value);
              if (Number.isFinite(v) && v >= 0) onChangeWages(v);
            }}
            className="w-full rounded-md border border-slate-300 py-2.5 pl-7 pr-4 font-mono text-base focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-200"
          />
        </div>
      </div>

      <div>
        <label
          htmlFor="withholding"
          className="block text-base font-medium text-slate-900"
        >
          Federal income tax withheld
        </label>
        <p className="mt-1 text-sm text-slate-500">
          From Box 2 of your W-2. This is what your employer already sent
          to the IRS on your behalf.
        </p>
        <div className="relative mt-2">
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
            $
          </span>
          <input
            id="withholding"
            type="number"
            inputMode="decimal"
            min={0}
            step={1}
            value={Number.isFinite(federalWithholding) ? federalWithholding : 0}
            onChange={(e) => {
              const v = e.target.value === '' ? 0 : Number(e.target.value);
              if (Number.isFinite(v) && v >= 0) onChangeWithholding(v);
            }}
            className="w-full rounded-md border border-slate-300 py-2.5 pl-7 pr-4 font-mono text-base focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-200"
          />
        </div>
      </div>
    </div>
  );
}